itsoftApp.createModule('babyFormInputs', ['noUiSliderLibrary'], function () {
    // Локальные переменные
    let module = this;

    function minMax(min, max, value) {
        return Math.min(max, Math.max(min, value));
    }

    function createBabyDateInput(name) {
      return `<input class="born-form__baby-age-input js-flatpicker-date" name="${name}" placeholder="дд/мм/гг" type="date" required>`;
    }

    const babyFormInputs = function () {
        ageInit();
        chidlrenCountInit();

        function ageInit() {
            const input = document.getElementById('born-form-age');

            if (input) {
                input.addEventListener('change', function (event) {
                    let val = event.target.value;

                    if (val.match(/[^0-9]/g)) {
                        event.target.value = val.replace(/[^0-9]/g, '');
                    }

                    if (!isNaN(Number(val))) {
                        event.target.value = minMax(15, 120, val);
                    }
                });
            }
        }

        function chidlrenCountInit() {
            const childrenCount = document.getElementById('children-count');

            if (childrenCount) {
                const inputTemplateMain = '<input class="born-form__baby-age-input js-flatpicker-date" name="baby-date-0" id="born-form-date-0" placeholder="дд/мм/гг" type="date" required>';
                const datesWrapper = document.getElementById('dates-wrapper'); // Контейнер для вставки

                childrenCount.addEventListener('change', function (event) {
                    let val = event.target.value;

                    if (val.match(/[^0-9]/g)) {
                        event.target.value = val.replace(/[^0-9]/g, '');
                    }

                    if (!isNaN(Number(val))) {
                        event.target.value = minMax(1, 6, val);

                        window.uiRangeSliders.babyBornCounter.noUiSlider.set(val);

                        if (datesWrapper) {
                            createAndInitFlicker(event.target.value);
                        }
                    }
                });

                function createAndInitFlicker(sliderNumbers) {
                    let result = inputTemplateMain;

                    for (let j = 0; j < sliderNumbers - 1; j++) {
                        result += createBabyDateInput(`baby-date-${j + 1}`);
                    }

                    datesWrapper.innerHTML = result;

                    const sliders = datesWrapper.querySelectorAll('.js-flatpicker-date');

                    sliders.forEach(slider => itsoftApp.modules.flatPickerLibrary.callback(slider));
                }
            }
        }
    };

    babyFormInputs();
    module.callback = babyFormInputs;
});
